export enum SearchRequestTypeEnum {
    Unknown = 0,
    SearchRequestSearchRequest = 1, 
    UserSearchRequest = 2, 
    RoleSearchRequest = 3, 
    ClaimTypeSearchRequest = 4, 
    NodeSearchRequest = 5, 
    PersonSearchRequest = 6, 
    OrganizationalUnitSearchRequest = 7, 
    ResourceSearchRequest = 8, 
    ActingProfileSearchRequest = 9, 
    ProductionSearchRequest = 10, 
    EngagementSearchRequest = 11,
    GroupSearchRequest = 12,
    MessageSearchRequest = 13,
    TaskSearchRequest = 14,
    WidgetSearchRequest = 15,
    ContactSearchRequest = 16,
    HtmlContentSearchRequest = 17,
    EmailMessageSearchRequest = 18,
    TextMessageSearchRequest = 19,
    ProductSearchRequest = 20
}
